module.exports = __webpack_public_path__ + "static/landing_phone-bccadd697ee11462d6941d447492c692.jpg";